import { createContext, useContext } from "react";
import { UserButton } from "@clerk/react";
import { Clock } from "lucide-react";
import { useResource } from "@/lib/api";

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

export default function AccessGate({ children }) {
  const { data: me, error } = useResource("/me");

  if (error) return <p className="p-8 text-destructive" data-testid="access-error">{error}</p>;
  if (!me) return <div className="p-8 font-mono text-sm text-muted-foreground" data-testid="access-loading">Loading…</div>;
  if (me.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" data-testid="awaiting-approval">
        <div className="max-w-md border border-border bg-card p-8 rise">
          <Clock className="h-6 w-6 text-amber-400" />
          <h1 className="font-display text-2xl font-semibold tracking-tight mt-4">Awaiting approval</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            You're signed in as <span className="font-mono text-foreground">{me.email}</span>. A director needs to
            approve this account before you can see the financial records.
          </p>
          <div className="mt-6"><UserButton /></div>
        </div>
      </div>
    );
  }
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}
